import React, { useEffect } from "react";
import useForm from "../../../../../hooks/useForm";
import useMutation from "../../../../../hooks/useMutation";
import Input from "../../../../form/Input";
import Modal from "../../../../elements/Modal";
import Button from "../../../../form/Button";
import CheckboxDropdown from "../../../../form/CheckboxDropdown";
import {
  applicationAddTitle,
  globalStepsList,
} from "../../../../../services/applicationFormService";
import useFetch from "../../../../../hooks/useFetch";

const AddFormTitleModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    resetField,
    setFieldsValue,
  } = useForm();

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ ...data });
    }
  }, [data]);

  useEffect(() => {
    if (!open) {
      resetField("title");
      resetField("selectedOptions");
    }
  }, [open]);

  const { data: stepsList } = useFetch({
    dependencies: ["stepsList", data?._id],
    fetchFunction: async () => {
      const res = await globalStepsList();
      return res?.data?.steps;
    },
  });

  const checkboxOptions = Array.isArray(stepsList)
    ? stepsList.map((item) => ({
        name: item.title,
        value: item.slug || item.code,
      }))
    : [];

  useEffect(() => {
    if (stepsList) {
      if (data?._id && Array.isArray(data?.steps)) {
        const matchedOptions = stepsList
          .filter((item) =>
            data.steps.some(
              (step) =>
                (step.slug || step?.code) === (item.slug || item.code)
            )
          )
          .map((item) => ({
            name: item.title,
            value: item.slug || item.code,
          }));
        setFieldsValue({ selectedOptions: matchedOptions });
      } else if (!data?._id) {
        const defaultSelected = stepsList.map((item) => ({
          name: item.title,
          value: item.slug || item.code,
        }));
        setFieldsValue({ selectedOptions: defaultSelected });
      }
    }
  }, [stepsList, data]);

  const modifiedSelectedOptions = (values?.selectedOptions || []).map(
    (item) => ({
      title: item.name,
      slug: item.value,
    })
  );

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      return await applicationAddTitle({
        title: val?.title,
        steps: modifiedSelectedOptions,
        ...(data?._id && { formId: data._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      close();
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <Modal isOpen={open} setIsOpen={close} size="lg" title={"Add Title"}>
      <form onSubmit={(event) => handleSubmit(event, mutate)}>
        <div className="grid grid-cols-12 gap-x-4 gap-y-4">
          <div className="relative col-span-12">
            <Input
              label="Form Title"
              inputPlaceholder="Enter Form Title"
              inputName="title"
              value={values?.title || ""}
              onChange={handleChange}
            />
          </div>

          <div className="relative col-span-12">
            <CheckboxDropdown
              label="Select Sections"
              dropDownData={checkboxOptions}
              selected={values?.selectedOptions || []}
              onChange={(selectedItems) => {
                // Sort selected items to match the order of stepsList
                const sortedSelectedItems = stepsList
                  .filter((step) =>
                    selectedItems.some(
                      (sel) => sel.value === (step.slug || step.code)
                    )
                  )
                  .map((step) => ({
                    name: step.title,
                    value: step.slug || step.code,
                  }));

                handleChange({
                  target: {
                    name: "selectedOptions",
                    value: sortedSelectedItems,
                  },
                });
              }}
            />
          </div>
        </div>

        <div className="relative col-span-4 mt-5">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType="submit"
              buttonLabel="Save"
              buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto"
              {...(isLoading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
            <Button
              buttonLabel="Cancel"
              buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto"
              buttonFunction={close}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AddFormTitleModal;
